// Re-export shared API
module.exports = require('./shared/api');
